import { useWizard } from "react-use-wizard";
import sellSteps from "../../sellSteps";
import { TKeyOfDataWizardSell, TStringKeysOfIFillDataWizardSell } from "../../..";
import CommunicateStep from "../../../../../../../shared/wizard/steps/communicateStep";
import { EDealRequestCommunicationType } from "../../../../../../../shared/wizard/steps/types";

interface IDoNotKnowPriceSwapStep_2 {
  onChange: (data: string, key: TStringKeysOfIFillDataWizardSell) => void;
  data: EDealRequestCommunicationType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPriceSwapStep_2 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPriceSwapStep_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_1);
    onReset(["communicationType"]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_3);
  };

  return (
    <div>
      <CommunicateStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default DoNotKnowPriceSwapStep_2;
